<template>
	<div class="main">
		<section class="panel panel-default" style="margin-bottom: 0px;" v-if="isAdmin('stay') ">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
			<div id="searchArea" class="panel-collapse collapse">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-12 ">
                            <div class="col-md-4">
                                <label class="col-md-4">住宿類型</label>
								<div class="col-md-8">
									<select v-model="dormitoryType" class="form-control">
										<option value="">--請選擇--</option>
										<option value="N">一般宿舍</option>
                                        <option value="V">寒暑假宿舍</option>
                                        <option value="S">特殊原因宿舍</option>
									</select>
								</div>
                            </div>
							<div class="col-md-4">
								<label class="col-md-4">學期</label>
								<div class="col-md-8">
									<select v-model="smtr" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(year, index) in selectYear()" :key="index" :value="year.value">{{year.text}}</option>
									</select>
								</div>
							</div>
                            <div class="col-md-4">
								<label class="col-md-4">審核狀態</label>
								<div class="col-md-8">
									<select v-model="applyStatus" class="form-control">
										<option value="">--請選擇--</option>
										<option value="A">待審核</option>
                                        <option value="Y">審核通過</option>
                                        <option value="N">審核不通過</option>
                                        <option value="R">退回</option>
									</select>
								</div>
                            </div>
						</div>
					</div>
					<div class="row form-group">
                        <div class="col-md-offset-4 col-md-4 ">
                            <div class="col-md-offset-4 col-md-4">
                                <button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
                            </div>
                        </div>
                    </div>
				</div>
			</div>
		</section>
		<section class="panel">
			<header class="panel-heading">
				<h2 class="panel-title">外宿請假單</h2>
			</header>
			<div class="panel-body container-fluid">
				<div class="row form-group">
					<div class="col-md-12 text-right form-inline">
						<router-link v-if="sessionData.accountType == 'STU'" :to="{name:'stay.overnight.apply', params:{account:this.account}}" class="btn btn-danger">新增外宿請假單</router-link>
            <router-link v-if="sessionData.accountType == 'ADM'" :to="{name:'stay.overnight'}" class="btn s_btn_g">返回</router-link>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<table class="table table-no-more table-bordered table-striped mb-none" >
							<thead>
								<tr>
									<th class="text-center" width="10%">學期</th>
									<th class="text-center" width="10%">住宿類別</th>
									<th class="text-center" width="10%">系科</th>
									<th class="text-center" width="10%">年級</th>
									<th class="text-center" width="10%">學生狀態</th>
									<th class="text-center" width="10%">學號</th>
									<th class="text-center" width="10%">姓名</th>
									<th class="text-center" width="10%">申請日期</th>
									<th class="text-center" width="10%">請假日期</th>
									<th class="text-center" width="10%">申請狀態</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in overnightList" :key="index">
									<td class="text-center" data-title="學期">
										{{item.smtr}}
									</td>
									<td class="text-center" data-title="住宿類別">{{item.dormitoryType == "V" ? "寒暑假住宿": (item.dormitoryType == "S" ? "特殊住宿": "一般學期住宿") }}</td>
									<td class="text-center" data-title="系科">{{item.deptCodeStr}}</td>
									<td class="text-center" data-title="年級">{{item.drade}}年{{item.dradeClass}}班</td>
									<td class="text-center" data-title="學生狀態">{{item.stateStr}}</td>
									<td class="text-center" data-title="學號">{{item.account}}</td>
									<td class="text-center" data-title="姓名">
										<a class="btn btn-link" @click="gotoView('stay.overnight.apply', {sno:item.sno, account:item.account, smtr:item.smtr, applyId:item.applyId})">{{item.name}}</a>
									</td>
									<td class="text-center" data-title="申請日期">{{customFormatter(item.crDate)}}</td>
									<td class="text-center" data-title="請假日期">{{customFormatter(item.overnightDate)}}</td>
									<td class="text-center" data-title="狀態">{{item.applyStatusStr}}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12">
						<div class="text-center" >
							<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
export default {
	data(){
		return {
            dormitoryType:"",
			accountType:"",
			overnightList:{},
			page:1,
			pageSize:10,
			totalPage:0,
			smtr:"",
            account:"",
            applyStatus:"",
		}
	},
	methods:{
		updateGrid(page) {
			//更新Grid 必需
			this.page = page;
			this.getInitData();
		},
		getInitData(){
            if (this.getStore(this.$route.name) != null) {
			    let storeData = JSON.parse(this.getStore(this.$route.name));
				this.smtr = storeData.smtr;
                this.account = storeData.account;
				this.dormitoryType=storeData.dormitoryType;
            }
			const api = "/api/RoomOvernight/overnightList";
            const ApiFunc = async ()=>{
                return await this.$axios.post(api, JSON.stringify({
                    page:this.page,
                    pageSize:10,
                    model:{
                        smtr:this.smtr,
                        dormitoryType:this.dormitoryType,
                        applyStatus:this.applyStatus,
                        account:this.account
                    }
                }));
            }
            Promise.resolve(ApiFunc()).then(resp => {
                this.overnightList = resp.data.data.rows;
                this.totalPage = resp.data.data.total
                this.page = resp.data.data.page;
            });

		},
		selectYear(){
			let smtrArray = [];
			if(!this.dormitoryType){
				return smtrArray;
			}
			for(let y = parseInt(this.applySmtr.substring(0,3)); y > 107 ; y--){
				if(this.dormitoryType == "N"){
					smtrArray.push({text:y+"年第二學期",value:y+"2"});
					smtrArray.push({text:y+"年第一學期",value:y+"1"});
				}else{
					smtrArray.push({text:y+"年",value:`${y}`});
				}
			}
			return smtrArray;
		},
	},
	mounted(){
		if(this.sessionData.accountType == "STU"){
			const contentVal = "請假注意事項：<br/>" +
			"一、 周一至周四幹部於23時30分前進行點名，有事需申請外宿的同學請於外宿1日前提出申請，逾時由生輔組視外宿事由評估是否准假。 <br/>"+
			"二、 每週五、六、日、國定假日及學校行事曆調整放假日，外宿不用申請。 <br/>"+
			"三、 每學期准假外宿15次（含），超出次數，由生輔組視請假事由檢討是否提前退宿。 <br/>"+
			"四、 不假外宿3次（含），由生輔組檢討提前辦理退宿。 <br/>"+
			"五、 學生因家庭事故、課表或意外事故（檢附證明文件），由生輔組檢討後，得不受上述規定約束。 <br/> "+
			"六、 上述規定如有未盡事宜，得適時補充說明。<br/> "
			bootbox.alert(contentVal);
		}
		this.getInitData();
	}
}
</script>
